export enum ChoiceSemesterPermissions {
  ChoiceSemester = 'choice-semester',
}
